import { siteConfig } from "../site-config";

const contactChannels = [
  { label: "Instagram", href: siteConfig.instagramUrl },
  { label: "WhatsApp", href: siteConfig.whatsappUrl },
  { label: "Email", href: siteConfig.emailUrl },
] as const;

export function Footer() {
  return (
    <footer className="site-footer" id="tentang">
      <div className="container footer-grid">
        <div className="footer-brand">
          <a className="footer-wordmark" href="#top">MOROLAB</a>
          <p>Desain, cetak, jadi.</p>
        </div>

        <nav className="footer-links" aria-label="Kanal kontak">
          {contactChannels.map((channel) => (
            channel.href ? (
              <a href={channel.href} key={channel.label} rel="noreferrer" target={channel.href.startsWith("http") ? "_blank" : undefined}>
                {channel.label}
              </a>
            ) : (
              <span aria-disabled="true" key={channel.label} title="Hubungkan kanal ini lewat .env.local">{channel.label}</span>
            )
          ))}
        </nav>

        <div className="footer-meta">
          <span>Indonesia</span>
          <span>© 2026 Morolab</span>
        </div>
      </div>
    </footer>
  );
}
